import { useTranslation } from 'react-i18next';

import { DataPanelGroup, DataPanelInlineItem, LocationSourceBadge, PanelInfoWithIcon, useDebugMode } from '@/ui';
import type { LocationRedacted } from '@/signalr';
import { DateFormatter } from '@/features/shared/DateFormatter';

export type RedactedLocationSummaryProps = {
  location: LocationRedacted;
};

export function RedactedLocationSummary({ location }: RedactedLocationSummaryProps) {
  const { t } = useTranslation();
  const debugModeOn = useDebugMode();

  return (
    <div className="bg-light p-2">
      <PanelInfoWithIcon icon="fal fa-location-crosshairs-slash" text={t('Incident_Location_Redacted')} />
      <div className="text-center small text-black-50 mt-1">{t('Incident_Location_Redacted_Description')}</div>
      {debugModeOn ? (
        <>
          <div className="d-flex justify-content-center my-2">
            <LocationSourceBadge source={location.source} />
          </div>
          <DataPanelGroup>
            <DataPanelInlineItem title={t('Incident_InfoPanel_LocationCapturedAt')}>
              <DateFormatter date={location.capturedAtUtc} formatType="calendar" />
            </DataPanelInlineItem>
            <DataPanelInlineItem title={t('Incident_InfoPanel_LocationReceivedAt')}>
              <DateFormatter date={location.receivedAtUtc} formatType="calendar" />
            </DataPanelInlineItem>
            <DataPanelInlineItem title={t('Incident_InfoPanel_LocationRedactedAt')}>
              <DateFormatter date={location.redactedAtUtc} formatType="calendar" />
            </DataPanelInlineItem>
          </DataPanelGroup>
        </>
      ) : (
        <DataPanelGroup>
          <DataPanelInlineItem title={t('Incident_InfoPanel_LocationCapturedAt')}>
            <DateFormatter date={location.capturedAtUtc} formatType="calendar" />
          </DataPanelInlineItem>
        </DataPanelGroup>
      )}
    </div>
  );
}
